<!--
 * @Author: your name
 * @Date: 2019-10-28 15:50:46
 * @LastEditTime: 2019-10-29 10:51:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /newOfficeIndex/src/components/chuangmeiqiPart/banner.vue
 -->
<template>
  <div id="banner-cont">
    <template>
      <Carousel v-model="value1" arrow="always" dots="none">
          <CarouselItem v-for="(v, i) in ~~2" :key="i">
            <div :class="['bg', `bg_${i}`]">
              <div class="main-cont">
                <div class="flex-lay-column">
                  <div class="img0"></div>
                  <div class="img1"></div>
                  <div class="img2"></div>
                </div>
              </div>
            </div>
          </CarouselItem>
      </Carousel>
    </template>
  </div>
</template>
<script>
export default{
  name: 'indexCont',
  data () {
    return {
      value1: 0
    }
  }
}
</script>
<style lang="scss">
#banner-cont{
  .bg{
    width: 100%;
    height: 6rem;
    @include bg-format;
    .main-cont{
      height: 100%;
      position: relative;
      .flex-lay-column{
        position: absolute;
        align-items: flex-start;
        top: 50%;
        transform: translateY(-50%);
      }
      .img0{
        height: 1rem;
        width: 3rem;
        background: url('../../assets/dawing/banner_img0.png');
        @include bg-format;
      }
      .img1{
        margin-top: .2rem;
        margin-bottom: .4rem;
      }
    }
  }
  .bg_0 .flex-lay-column{
    right: .4rem;
  }
  .bg_1 .flex-lay-column{
    left: 1.3rem;
  }
  .bg_0 .img1{
    height: 2rem;
    width: 1.8rem;
    background: url('../../assets/dawing/banner_img10.png');
    @include bg-format;
  }
  .bg_0 .img2{
    height: .3rem;
    width: 2.4rem;
    background: url('../../assets/dawing/banner_txt_0.png');
    @include bg-format;
  }
  .bg_1 .img1{
    height: 1rem;
    width: 3.6rem;
    background: url('../../assets/dawing/banner_img11.png');
    @include bg-format;
  }
  .bg_1 .img2{
    height: .4rem;
    width: 1.6rem;
    background: url('../../assets/dawing/banner_txt_1.png');
    @include bg-format;
  }
  /deep/ .ivu-carousel-arrow{
    width: .7rem;
    height: .7rem;
    border-radius: 0.1rem;
    i{
      font-size: .5rem;
    }
  }
  @for $i from 0 to 2 {
    .bg_#{$i} {
      background-image: url('../../assets/dawing/banner_#{$i}.png');
      @include bg-format;
      background-size: cover;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DAWNING/banner.vue